// @file Types for presentation modes (Slideshow, Virtual Field Trip)

type PresentationMode = 'slideshow' | 'field-trip'

enum PresentationPageType {
  Cover = 'cover',
  Section = 'section',
  Group = 'group',
  Wish = 'wish',
}

type CoverPage = { pageType: PresentationPageType.Cover }
type SectionPage = {
  pageType: PresentationPageType.Section
  sectionId: number | string
}
type GroupPage = {
  pageType: PresentationPageType.Group
  groupId: number | string
}
type WishPage = {
  pageType: PresentationPageType.Wish
  wishId: number | string
}

type PresentationPage = CoverPage | SectionPage | GroupPage | WishPage

// Loose page representation used for internal navigation (page lists, current page tracking).
// Prefer PresentationPage (discriminated union) for URL construction.
interface Page {
  pageType: PresentationPageType
  entityId?: string
}
export { PresentationPageType }
export type { PresentationMode, PresentationPage, Page }
